import {Injectable} from "@angular/core";
import {OauthService} from "./oauth.service";
import {Subject} from "rxjs/Subject";
import {Http} from "@angular/http";
import {App} from "ionic-angular";
import {AppProvider} from "../../core/app/app-provider.service";
import {ToolsService} from "./tools.service";
import {HttpParams} from "@angular/common/http";

@Injectable()
export class EnvironnementService extends OauthService {

  public loader = new Subject<boolean>();

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);

    this.loader.next(true); // init custom loader
  }

  getEnvironnement(version, client): any {
    const url = this.Routing.generate('api_app_ekipea_api_versionenvironnement_get', {'_format': 'json', version: version, client: client}, true);

    return this.http
      .get(`${url}`)
      .map(response => {
        return response.json().data;
      });
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/environnement.service.ts